<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="(item,index) in mateList"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
      <el-form class="search-style" label-width="70px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="物流单号：">
              <el-input v-model="valList[0].value"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="物流公司：">
              <el-input v-model="valList[1].value"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="寄件时间：">
              <el-date-picker
                v-model="valList[2].value"
                type="date"
                style="width:100%"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="padding-top:20px">
          <el-col :span="8">
            <el-form-item label="承担人：">
              <el-input v-model="valList[3].value"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" @click="onSearch">搜索</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-col>
          <el-col :span="8">
            <div style="text-align: right">
              <el-button type="primary" @click="newAdd">新增</el-button>
              <el-button @click="leadInProduct">导入</el-button>
              <el-button @click="onExport">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="box-table" :style="{height: $store.state.Sell.height-48+'px'}">
        <el-table
          border
          :max-height="$store.state.Sell.height-50"
          ref="tableRef"
          :data="list"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column label="物流单号" prop="logicNumber"></el-table-column>
          <el-table-column prop="logicCompany" label="物流公司"></el-table-column>
          <el-table-column prop="deliveryDate" label="寄件时间">
            <template slot-scope="scope">{{ scope.row.deliveryDate | dateFilterL }}</template>
          </el-table-column>
          <el-table-column prop="bearUser" label="承担人"></el-table-column>
          <el-table-column prop="weight" label="货物重量（kg）">
            <template slot-scope="scope">{{ scope.row.weight | priceFilter }}</template>
          </el-table-column>
          <el-table-column prop="expensePayer" label="物流费用付款方"></el-table-column>
          <el-table-column prop="logisticsCost" label="物流费用">
            <template slot-scope="scope">{{ scope.row.logisticsCost | priceFilter }}</template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="write(scope.row)" v-if="activeName !=='1'">填写</el-button>
              <el-button type="text" @click="look(scope.row)" v-if="activeName ==='1'">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
    <el-dialog title="物流信息" width="820px" :visible.sync="dialogFormVisible">
      <el-form class="details-line-height" style="padding:0 26px">
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="物流单号："
              :rules="filter_rules({required:true})"
            >{{queryParams.logicNumber}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="物流公司："
              :rules="filter_rules({required:true})"
            >{{queryParams.logicCompany}}</el-form-item>
          </el-col>
          <el-row style="margin-bottom:10px">
            <el-col :span="12">
              <el-form-item
                label="寄件时间："
                :rules="filter_rules({required:true})"
              >{{queryParams.deliveryDate|dateFilterD}}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="承担人："
                :rules="filter_rules({required:true})"
              >{{queryParams.bearUser}}</el-form-item>
            </el-col>
          </el-row>
          <el-col :span="12">
            <el-form-item label="寄件人：">{{queryParams.deliveryPeople}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="寄件人电话：">{{queryParams.deliveryPhone}}</el-form-item>
          </el-col>
          <el-col :span="24" style="margin-bottom:10px">
            <el-form-item label="寄件地址：">{{queryParams.deliveryAddress}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收件人：">{{queryParams.receivePeople}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收件人电话：">{{queryParams.receivePhone}}</el-form-item>
          </el-col>
          <el-col :span="24" style="margin-bottom:10px">
            <el-form-item label="收件地址：">{{queryParams.receiveAddress}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="结算重量："
              :rules="filter_rules({required:true})"
            >{{queryParams.weight}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="总体积：">{{queryParams.totalVolume?queryParams.totalVolume+' m³':''}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="总件数：">{{queryParams.total}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="包装：">{{queryParams.packing}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保价金额：">{{queryParams.insuredLogisticsCost|priceFilter}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运输方式：">{{queryParams.transportType}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="物流费用付款方："
              :rules="filter_rules({required:true})"
            >{{queryParams.expensePayer}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="物流费用："
              :rules="filter_rules({required:true})"
            >{{queryParams.logisticsCost|priceFilter}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 新增弹框 -->
    <log-exper-set-dialog :selectList="selectList" ref="logExperSetDialogRefs" @onInit="onReset"></log-exper-set-dialog>
    <lead-in @onRefresh="onReset" ref="batchInRefs"></lead-in>
  </div>
</template>
<script>
import leadIn from '@/components/leadIn/batchIn'
import LogExperSetDialog from './LogExperSetDialog'
import pagination from '@/components/pagination'
import { mateList } from '../financeManage/util/data'
import {
  queryFinancelogistic,
  queryPageAllByState,
  allRole,
  financeLogisticCoeDerive
} from '@/api/fiance/fianceManage'
import { downLoadFileBlob } from '@/util/tool'
export default {
  components: {
    pagination,
    'lead-in': leadIn,
    'log-exper-set-dialog': LogExperSetDialog
  },
  data () {
    return {
      valList: [
        { value: '', column: 'logicNumber' },
        { value: '', column: 'logicCompany' },
        { value: '', column: 'deliveryDate' },
        { value: '', column: 'bearUser' }
      ],
      columnArr: [],
      queryParams: {},
      dialogFormVisible: false,
      selectList: [], // 承担人列表
      activeName: '1', // tabs选中状态
      mateList, // tabs状态
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      loadingTable: false, // 列表loading
      list: [] // 列表数据
    }
  },
  created () {
    this.getList()
    allRole().then((res) => {
      if (res.data.code === 200) {
        this.selectList = res.data.obj
      } else {
        this.$message.error(res.data.msg)
      }
    })
  },
  methods: {
    onExport () {
      const obj = {
        logisticUrl: this.$store.state.financeLogisticCoeDerive,
        queryCriteriaVo: {
          criteriaVoList: [...this.columnArr],
          queryPageName: ''
        },
        state: this.activeName
      }
      financeLogisticCoeDerive(obj).then((res) => {
        downLoadFileBlob(this, res)
      })
    },
    leadInProduct () {
      // 导入表格
      queryFinancelogistic().then(res => {
        if (res.data.code === 200) {
          this.$refs.batchInRefs.onLeadIn(
            this.$store.state.financeLogisticCoeDerive,
            '财务-导入物流信息'
          )
        }
      })
    },
    getList () {
      this.loadingTable = true
      const params = {
        criteriaVoList: [...this.columnArr],
        queryPageName: ''
      }
      queryPageAllByState(
        this.activeName,
        this.currentPage,
        this.pageSize,
        params
      ).then((res) => {
        if (res.data.code === 200) {
          this.list = res.data.obj.records
          this.total = res.data.obj.total
          this.loadingTable = false
        } else {
          this.$message.console.error(res.data.msg)
        }
      })
    },
    // 搜索
    onSearch () {
      this.columnArr = []
      if (this.valList.some((m) => m.value)) {
        this.currentPage = 1
        this.pageSize = 30
        this.valList.forEach((ele) => {
          if (ele.value) {
            ele.collection = true
            this.columnArr.push(ele)
          }
        })
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    onReset () {
      this.currentPage = 1
      this.pageSize = 30
      this.valList.forEach((m) => delete m.value)
      this.columnArr = []
      this.getList()
    },
    // 新增
    newAdd () {
      this.$refs.logExperSetDialogRefs.init(1)
    },
    write (row) {
      this.$refs.logExperSetDialogRefs.init(2, row)
    },
    look (row) {
      this.dialogFormVisible = true
      this.queryParams = row
      // this.$refs.logExperSetDialogRefs.init(3, row)
    },
    // tabs切换时触发的事件
    handleClick () {
      this.currentPage = 1
      this.pageSize = 30
      this.onReset()
    },
    // 页数
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
